module.exports = __webpack_public_path__ + "img/icon_5_80.1f8e6140.png";